module.exports = __webpack_public_path__ + "img/aliens-background.714530b3.png";